/*
 *   File : next-follow.js
 *   Author : https://evoqins.com
 *   Description : Set next follow-up date tab file
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Modal } from 'bootstrap';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { format } from 'date-fns';

//Custom components
import { CustomDatePicker } from '../../../Components/FormElements';
import { PrimaryButton } from '../../../Components/Buttons';
import { ConfirmModal } from '../../../Components/Modal';
import { APIService } from '../../../Service';

const NextFollowDate = (props) => {

    const calendarRef = useRef(null);

    const { id } = useParams();

    const [confirm, setConfirm] = useState(false);
    const [status, setStatus] = useState(false);

    const [selectedDate, setSelectedDate] = useState(null);
    const [calendarToggle, setCalendarToggle] = useState(false);
    const [dateError, setDateError] = useState("");
    const [buttonLoader, setButtonLoader] = useState(false);

    useEffect(() => {
        if (props.data.next_follow_up_date) {
            const updated_date = new Date(props.data.next_follow_up_date);
            setSelectedDate(updated_date);
        }
    }, [props.data]);

    useEffect(() => {
        setDateError("");
    }, [selectedDate]);

    useEffect(() => {
        if (confirm === true) {
            const confirm_modal = new Modal(document.getElementById('confirm-modal'));
            confirm_modal.show();
        }
    }, [confirm]);

    // handle toggle date picker 
    const _handleToggleCalendar = () => {
        setCalendarToggle(!calendarToggle);

        if (calendarRef.current) {
            calendarRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    // handle select date 
    const _handleSelectDate = (day) => {
        setSelectedDate(day);
        setCalendarToggle(false);
    };

    // handle clear date
    const _handleClearDate = () => {
        setSelectedDate(null);
    };

    // handle add next follow up date
    const _handleAdd = () => {
        if (selectedDate === null) {
            setDateError("Please select next follow up date");
            return;
        }
        setConfirm(true);
    };

    // API - Update lead
    const _updateLead = () => {
        let is_post = true;
        let url = 'lead/update-lead';
        let data = {
            "lead_id": Number(id),
            "note": null,
            "note_id": null,
            "type": 2,
            "next_follow_up_date": format(selectedDate, "yyyy-MM-dd"),
            "lead_stage_id": null
        };
        setButtonLoader(true);

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setStatus(true);
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
            setButtonLoader(false);
        });
    };

    return (
        <Fragment>
            <div className='padding-32px-all min-vh-50'>
                <h4 className='mb-0 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                    Set next follow up date
                </h4>

                <div ref={calendarRef} className='padding-26px-top row'>
                    {/* Select date */}
                    <div className='col-4'>
                        <CustomDatePicker label="Select date"
                            placeholder="Select date"
                            selected={selectedDate}
                            toggle={calendarToggle}
                            required={true}
                            error={dateError}
                            future={true}
                            handleToggle={_handleToggleCalendar}
                            handleClose={_handleToggleCalendar}
                            handleClear={_handleClearDate}
                            handleSelect={_handleSelectDate} />

                        <div className='pt-4 mt-2 text-end'>
                            <PrimaryButton name="Add"
                                paddingBlock="py-3 padding-80px-lr"
                                onClick={_handleAdd} />
                        </div>
                    </div>
                </div>
            </div>

            {/* confirm modal */}
            {confirm === true &&
                <ConfirmModal title={status ? "Next follow up date set" : "Confirm next follow up date"}
                    description={status ?
                        <>
                            The next follow-up date has been successfully set for <span className="e-font-weight-600 d-inline-flex">{format(selectedDate, "dd MMM yyyy")}</span>. A reminder will be sent to ensure timely follow-up with this lead.
                        </>
                        :
                        "Are you sure you want to change the stage of this lead from Opportunity to Customer? This action will update the lead's status in the sales pipeline and may impact future follow-ups."}
                    status={status}
                    loader={buttonLoader}
                    handleClose={() => {
                        setTimeout(() => {
                            setConfirm(false);
                            setStatus(false);
                        }, 200);
                    }}
                    handleConfirm={() => _updateLead()}
                    handleSuccess={() => {
                        setTimeout(() => {
                            setConfirm(false);
                            setStatus(false);
                            // setSelectedDate(null);
                            props.handleUpdate();
                        }, 200);
                    }} />
            }
        </Fragment>
    )
}

export default NextFollowDate;
